import {connect} from 'react-redux'
import TopToolbar from "../../Components/Toolbars/TopToolbar/TopToolbar";
import * as logActions from "../actions/logActions";

const mapStateToProps = (store) => {
    return {
        isAutopilot: store.businessReducer.business.isAutopilot,
        isDemo: store.businessReducer.business.isDemo,
        minAddressChangeRecommendationDialog: store.businessReducer.business.minAddressChangeRecommendationDialog,
        kibanaUrl: store.businessReducer.business.kibanaUrl,
        numberOfMessengersOnShift: store.usersReducer.users.filter(user => _.get(user, "profiles.messenger.isCurrentlyOnShift")).length,
        numberOfAvailableMessengers: store.usersReducer.users.filter(user => _.get(user, "profiles.messenger.isCurrentlyOnShift") && _.get(user, "profiles.messenger.isCurrentlyAvailable")).length
    };
};

const mapDispatchToProps = {
    logInfo: logActions.logInfoAction
};

const TopToolbarContainer = connect(mapStateToProps, mapDispatchToProps)(TopToolbar);

export default TopToolbarContainer;